.openhjelpeskuff {
  display: block;
}
